<template>
  <v-container fluid class="tw-my-6">
    <slot></slot>
  </v-container>
</template>

<script>
export default {
  name: 'ripa-content-wrapper',
}
</script>
